import { render, staticRenderFns } from "./GenerationCourse.vue?vue&type=template&id=3bcfc8c6&scoped=true&"
import script from "./GenerationCourse.vue?vue&type=script&lang=js&"
export * from "./GenerationCourse.vue?vue&type=script&lang=js&"
import style0 from "./GenerationCourse.vue?vue&type=style&index=0&id=3bcfc8c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcfc8c6",
  null
  
)

export default component.exports